import { render, staticRenderFns } from "./AppointmentsExportDialog.vue?vue&type=template&id=d672dc04"
import script from "./AppointmentsExportDialog.vue?vue&type=script&lang=ts"
export * from "./AppointmentsExportDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports